/**
 * Access the auth state + actions.
 *
 * Must be used inside <AuthProvider> (mounted in main.tsx).
 *
 * Lives in its own file so react-refresh can HMR <AuthProvider>
 * cleanly without invalidating every consumer of useAuth.
 */

import { useContext } from 'react';

import { AuthContext } from './AuthContext';
import type { AuthContextValue } from './AuthContext';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an <AuthProvider>');
  }
  return ctx;
}
